export default __webpack_public_path__ + "static/media/pattern.89a88957.pdf";